<template>
    <copy-calendarevent-component
            :data-url="dataUrl"
            :save-url="saveUrl"
            :ajax-operations-url="ajaxOperationsUrl"
            :buttons="buttons"
            :title="translate('Új próba meglévő alapján')"
            :choose-label="translate('Válasszon egy próbát')"
            v-on:component="$emit('component', $event)"
            v-on:submit-success="$emit('submit-success')"
            v-on:editing-canceled="$emit('editing-canceled')"
    ></copy-calendarevent-component>
</template>

<script>
    import {editformReplacementMixin} from "./mixins/editformReplacementMixin";

    export default {
        mixins: [editformReplacementMixin],
        props: {
            title: {},
        },
        data: function () {
            return {}
        },
        mounted() {
        },
        methods: {},
        computed: {},
        watch: {}

    }
</script>
